import styled from "styled-components";
import {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  COLORS,
  TEXT_COLORS,
} from "../../constants/design/colors";
import { SPACING } from "../../constants/design/spacing";
import { TableWrapper } from "../Table/style";

export const MegaToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.two}px;
  margin-bottom: ${SPACING.three}px;
`;

export const MegaSummary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.three}px;
  color: ${TEXT_COLORS.one};
`;

export const MegaSearch = styled.input`
  background: ${BACKGROUND_COLORS.component};
  border: 1px solid ${BORDER_COLORS.two};
  border-radius: 6px;
  color: ${TEXT_COLORS.one};
  padding: ${SPACING.two}px;
  width: 300px;
  max-width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: 1px solid ${COLORS.blue.one};
  }
`;

export const MegaHint = styled.p`
  color: ${TEXT_COLORS.two};
  font-size: 13px;
  margin: 0 0 ${SPACING.three}px;
`;

export const MegaNotice = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACING.two}px;
  color: ${COLORS.orange.one};
  margin-bottom: ${SPACING.three}px;
`;

export const MegaTableWrapper = styled(TableWrapper)`
  table {
    width: 100%;
    min-width: 1080px;
    table-layout: fixed;

    th,
    td {
      padding: ${SPACING.two}px;
      text-transform: none;
    }

    tfoot th,
    tfoot td {
      border-top: 1px solid ${BORDER_COLORS.two};
      color: ${TEXT_COLORS.one};
      font-weight: 600;
    }

    tfoot th {
      text-align: left;
    }
  }
`;

export const AccountCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  > button {
    flex-shrink: 0;
  }
`;

export const AccountLabel = styled.a`
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${COLORS.blue.one};
  text-decoration: none;
`;

export const RewardCell = styled.div`
  text-align: right;

  small {
    display: block;
    color: ${TEXT_COLORS.two};
  }
`;

export const StatusCell = styled.div`
  white-space: normal;
  overflow-wrap: anywhere;
  color: ${TEXT_COLORS.two};
`;
